




import { Component, Vue } from "vue-property-decorator";
import AuthService from "./utils/AuthService";
import { User } from "oidc-client";
import { EventBus, EventBusMessage } from "@gis/common";
import { GlobalMessageHelper } from "@gis/common";

@Component({ name: "App" })
export default class VueApp extends Vue {
    currentUser: User | null = null;

    mounted(): void {
        //Is anyone logged in yet?
        AuthService.getUser()
            .then((user) => {
                this.currentUser = user;
            })
            .catch((e) => {
                console.error(e);
            });

        EventBus.$on(EventBusMessage.UNAUTHORIZED, async () => {
            if (await AuthService.ensureUserIsLoggedIn()) {
                EventBus.error("User is unauthorized!");
            }
        });

        EventBus.$on(EventBusMessage.ACCESS_DENIED, async () => {
            this.$router.push("accessDenied");
        });

        GlobalMessageHelper.init();
    }
}
